<script setup>
import {computed, defineProps} from "vue";
import {couponConf} from "@/utils/config";
import router from "@/router";
import store from "@/store";
import {onMounted, ref} from "vue";
import {useRoute} from "vue-router";
import axiosApi from "@/utils/axiosApi";
import ActiveXmairComponent from "@/components/xm-actives/ActiveXmairComponent.vue";

defineProps({
  couponLst: {
    type: Array,
    default: () => {
      return [];
    },
  },
  account: {
    type: Object,
    default: () => {
      return {};
    },
  },
  type: {
    type: Object,
    default: () => {
      return couponConf["tm-xmair"];
    }
  }
});
const getDetail = (cou) => {
  store.commit('setCouponIts', cou)
  router.push({name: 'detail', params: {id: cou.id}})
}
const from = computed(()=>store.state.orderFrom)
const showPayLoading = ref(false)
const success = require("@/assets/images/tm/success.png")
const route = useRoute()
onMounted(() => {
  if (route.query.order) {
    new axiosApi({
      encode: "coupon",
      method: "goods_category/query",
      body: {ordersn: route.query.order}
    }).send((res) => {
      if (res.message.code === "000" && (res.data.state === 1 || res.data.state === 2)) {
        showPayLoading.value = true
      }
    })
  }
})
</script>

<template>
  <div class="tm-card-items">
    <!--{{ couponLst }}-->
    <el-image src="https://images.jifen360.com/tm_mark/recharge.png"/>
    <div class="tm-coupon-lst">
      <div class="tm-coupon-info" v-for="cou in couponLst" :key="cou.id">
        <div class="tm-coupon-face-value">
          <div class="tm-coupon-face-value-money">
            <div class="tm-face-value-unit">￥</div>
            <div class="tm-coupon-face-value-money">
              {{ parseFloat(cou.face_value) }}
            </div>
          </div>
          <div class="tm-logo">
            <el-image src="https://images.jifen360.com/tm_mark/tm-log.png"/>
          </div>
        </div>
        <div class="tm-coupon-value">
          <h4>{{ cou.goods_name }}</h4>
          <div class="tm-coupon-value-info">
            <div class="tm-coupon-value-jingle">
              <div class="coupon-face-money">
                <el-text type="danger">{{ cou.mileTypes.xm_air.total }}</el-text>
                <el-text type="info">积分</el-text>
              </div>
            </div>
            <div class="tm-coupon-value-button">
              <el-button type="danger" round size="small" @click="getDetail(cou)">立即兑换</el-button>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
  <active-xmair-component v-if="from === 'xm_air' || from=== 'brand'"/>
  <el-dialog v-model="showPayLoading" :show-close="false" width="85%" class="success-box"
             style="border-radius: 20px;padding: 25px" @closed="showPayLoading=false,router.replace({name: 'home'})">
    <div class="success-image">
      <el-image :src="success"></el-image>
    </div>
    <div class="success-tips">
      <el-text type="info">
        下载并打开“淘宝APP”-首页找到并点击“天猫超市”-底部菜单栏点击“我的”-点击“超市卡”-点击“明细”查看并使用。
      </el-text>
    </div>
    <div class="success-btn">
      <el-button type="primary" class="cancel" @click="showPayLoading=false,router.replace({name: 'home'})">返回首页
      </el-button>
      <el-button type="primary" @click="router.replace({name: 'order'})">兑换记录</el-button>
    </div>
    <el-icon class="close-btn" size="35" @click="showPayLoading=false,router.replace({name: 'home'})">
      <CircleClose/>
    </el-icon>
  </el-dialog>
</template>

<style scoped lang="less">
.tm-card-items {
  background: #ffffff;
  border-radius: 12px;
  margin: 15px;

  .tm-coupon-lst {
    box-sizing: border-box;
    padding: 10px;

    .tm-coupon-info {
      position: relative;
      height: 85px;
      background: #ffffff;
      border-radius: 8px;
      display: flex;
      margin-bottom: 15px;

      .tm-coupon-face-value {
        position: relative;
        width: 30%;
        //flex-basis: 30%;
        background: #6DC43D;
        border-radius: 8px 0 0 8px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: white;
        z-index: 0;

        .tm-coupon-face-value-money {
          display: flex;
          justify-content: center;

          .tm-coupon-face-value-money {
            font-size: 1.35rem;
          }

          .tm-face-value-unit {
            font-size: .7rem;
          }
        }

        .tm-logo {
          width: 55%;
          margin-top: 5px;
        }
      }

      .tm-coupon-value {
        position: relative;
        flex: 1;
        padding: 12px;
        box-sizing: border-box;
        background: #F2FEE2;
        border-radius: 0 8px 8px 0;
        z-index: 1;
        //display: flex;
        //justify-content: space-between;
        line-height: 1.75;
        //align-items: center;

        .tm-coupon-value-info {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .coupon-face-money {
          white-space: nowrap;

          .el-text--danger {
            font-size: 1.32rem;
          }

          .el-text--info {
            font-size: .7rem;
          }
        }

        &::before,
        &::after {
          content: '';
          position: absolute;
          left: -8px;
          width: 16px;
          height: 16px;
          background: #ffffff;
          //z-index: 999;
          /* 需与页面背景色一致 */
        }

        &::before {
          /* 上缺角 */
          top: -8px;
          border-radius: 0 0 10px 10px;
        }

        &::after {
          /* 下缺角 */
          bottom: -8px;
          border-radius: 10px 10px 0 0;
        }
      }
    }
  }
}

.success-box {
  position: relative;

  .success-image {
    text-align: center;

    .el-image {
      width: 120px;
    }
  }

  .success-tips {
    text-align: justify-all;
    line-height: 1.7;
    margin: 15px auto;
  }

  .success-btn {
    display: flex;
    justify-content: space-between;

    .el-button {
      width: 48%;
    }

    .cancel {
      border-color: var(--el-color-info);
      background: none;
      color: var(--el-color-info);
    }
  }

  .close-btn {
    position: absolute;
    //bottom: 800px;
    //bottom: 15px;
    z-index: 9999;
    bottom: -45px;
    color: #ffffff;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>